import React from 'react';
import PropTypes from 'prop-types';

const DropdownItem = ({
  onClick,
  ticker,
  middleName,
  className,
  children,
  componentRefs,
  component,
  showTicker,
  isLarge,
  isLocked,
}) => {
  return (
    <div
      ref={el => {
        if (componentRefs && component) {
          componentRefs[component] = el;
        }
      }}
      onClick={onClick}
      className={className}
    >
      <div className="d-flex">
        <div className={`ticker-name ${isLarge ? 'is-large' : ''}`}>
          {showTicker ? ticker : ''}
        </div>
        <div className="text-truncate ml-3 middle-name">
          <span dangerouslySetInnerHTML={{ __html: middleName }} />
          {isLocked && <i className="icon-padlock" />}
        </div>
      </div>
      {children}
    </div>
  );
};

DropdownItem.propTypes = {
  onClick: PropTypes.func,
  ticker: PropTypes.string.isRequired,
  middleName: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

DropdownItem.defaultProps = {
  showTicker: true,
};

export default DropdownItem;
